import { useEffect, useState } from "react";
import {
  BrowserRouter,
  Link,
  Navigate,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import { Status, useSession } from "./session/Context";
import Dashboard from "./pages/Dashboard";
import UserDashboard from "./private_pages/Dashboard";
import AddIssuance from "./private_pages/AddIssuance/AddIssuance";
import Onboarding from "./private_pages/Onboarding";
import Issuer from "./private_pages/Issuer";
import Login from "./pages/Login";
import Issue from "./pages/Issue";
import { stat } from "fs";
import { Cookies, useCookies } from "react-cookie";
import HeaderNoAuth from "./header/HeaderNoAuth";
import HeaderAuth from "./header/HeaderAuth";
import LogoutButton from "./pages/Logout";
import TermsConditions from "./pages/Terms&conditions";
import PrivacyPolicy from "./pages/Privacy_policy";
import Navbar from "./private_pages/Navbar";
import Sidebar from "./private_pages/Sidebar";
import Notifications from "./private_pages/Notifications";
import Plus from "./private_pages/Plus";
import CreateTemplate from "./private_pages/CreateTemplate";
import CreateCredential from "./private_pages/CreateCredential/CreateCredential";
import Details from "./private_pages/DashboardCredentialDetails/Details";
import FooterText from "./Footer/Footer";
import LeftPanel from "./LeftPanel/LeftPanel";
import SelectWallet from "./pages/SelectWallet";
import CardDetails from "./private_pages/DashboardCredentialDetails/CardDetails";
import ApiKey from "./private_pages/Settings/ApiKey";
import AccountSettings from "./private_pages/Settings/AccountSetings";
import CreateSchema from "./private_pages/CreateSchema";
import CreateGhost from "./private_pages/CreateGhost";
import KeyManagement from "./private_pages/Settings/KeyManagement";
import CreateAuthCredential from "./private_pages/CreateAuthCredential";

import "../css/index.css";
import { background } from "@chakra-ui/react";
import IssuanceDetails from "./private_pages/CreateCredential/IssuanceDetails";

interface LandingProps {}

export function Landing(props: LandingProps) {
  const {
    status,
    brand,
    error_reason,
    cookie,
    is_admin,
    is_onboarded,
    onboarding,
  } = useSession();
  const navigate = useNavigate();
  const [cookies, setCookies] = useCookies([cookie.name]);

  // For PRO version - navigation control
  const [sidebarOpen, setsidebarOpen] = useState(false);
  const openSidebar = () => {
    setsidebarOpen(!sidebarOpen);
  };
  const closeSidebar = () => {
    setsidebarOpen(false);
  };

  // Notifications - for user approval
  const [notifNum, setNotifNum] = useState(0);
  const [notifData, setNotifData] = useState();
  const [activeCredential, setActiveCredential] = useState();



  useEffect(() => {
    if (status === Status.ERROR) {
      if (error_reason == "no such session") {
        setCookies(cookie.name, "");
        navigate("/login");
      }
    }
    if (status === Status.LOADED) {
      if (!is_onboarded && !onboarding) {
        navigate("/onboarding");
      } else if (!is_onboarded && onboarding) {
        // navigate to wait to be onboarded screen
      }
    }
  }, [status]);

  if (status === Status.LOADING) {
    return <>Loading ...</>;
  } else if (status === Status.NOTHING) {
    return (
      <>
        <div className="container">
          <HeaderNoAuth />
          <main>
            <Routes>
              <Route path="/" element={<Dashboard />}></Route>
              <Route path="/login" element={<Login />}></Route>
              <Route path="/issue" element={<Issue />}></Route>
              <Route path="/offer" element={<SelectWallet />}></Route>
              <Route
                path="/terms"
                element={<TermsConditions />}
              ></Route>
              <Route
                path="/privacy"
                element={<PrivacyPolicy />}
              ></Route>
              <Route path="*" element={<Navigate to="/" />}></Route>
            </Routes>
            <FooterText style="m-show" />
          </main>
          <LeftPanel heading="Issuer" fontSize="120px" />
        </div>
      </>
    );
  }
  // USER IS ONBOARDING
  else if (!is_onboarded) {
    return (
      <>
        <div className="container">
          <HeaderAuth />
          <LeftPanel heading="Onboarding" fontSize="120px" />
          <main>
            <Routes>
              <Route path="/" element={<Onboarding />}></Route>
              <Route
                path="/onboarding"
                element={<Onboarding sessionStatus={status} />}
              ></Route>
              <Route path="/issue" element={<Issue />}></Route>
              <Route path="/offer" element={<SelectWallet />}></Route>
              <Route
                path="/terms"
                element={<TermsConditions />}
              ></Route>
              <Route
                path="/privacy"
                element={<PrivacyPolicy />}
              ></Route>
              <Route path="/logout" element={<LogoutButton />}></Route>
              <Route path="*" element={<Navigate to="/" />}></Route>
            </Routes>
            <FooterText style="m-show" />
          </main>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="container">
        <Navbar
          notification={notifNum}
        />
        <main /* className={` grid-wrapper-pro  protect`} */>
          <Routes>
            <Route path="*" element={<Navigate to="/" />}></Route>
            <Route path="/" element={<Navigate to="/dashboard" />}></Route>
            <Route
              path="/dashboard"
              element={
                <UserDashboard
                  onDetails={(activeCredential: any) => {
                    setActiveCredential(activeCredential);
                  }}
                />
              }
            ></Route>
            <Route
              path="/notifications"
              element={<Notifications notifData={undefined} />}
            ></Route>
            <Route path="/issue" element={<Issue />}></Route>
            <Route path="/issuer" element={<Issuer />}></Route>
            <Route path="/add_issuance" element={<AddIssuance />}></Route>
            <Route path="/create_credential" element={<CreateCredential />} ></Route>
            <Route path="/issuance_details" element={<IssuanceDetails  />} ></Route>
            <Route path="/create_template" element={<CreateTemplate />}></Route>
            <Route path="/create_schema" element={<CreateSchema />}></Route>
            <Route path="/offer" element={<SelectWallet />}></Route>
            <Route
              path="/details"
              element={<Details credential={activeCredential} />}
            ></Route>
            <Route path="/api_key" element={<ApiKey />}></Route>
            <Route path="/key_management" element={<KeyManagement />}></Route>
            <Route path="/settings" element={<AccountSettings />}></Route>

            <Route
              path="/terms"
              element={<TermsConditions />}
            ></Route>

            {/* for admin only ! */}
            <Route path="/create_ghost" element={<CreateGhost />}></Route>

            <Route
              path="/privacy"
              element={<PrivacyPolicy />}
            ></Route>
            <Route path="/logout" element={<LogoutButton />}></Route>
          </Routes>
          <FooterText style="m-show" />
          <Plus destination="create_credential"/>          
        </main>

        <Sidebar />
      </div>
    </>
  );
}
